import { type ReactElement, type ReactNode } from 'react'
import { escapeRegExp } from 'lodash'
import reactStringReplace from 'react-string-replace'

const getHighlightsRegexp = (highlights: string[]): RegExp | undefined => {
  const keywords = highlights.filter(Boolean).map(escapeRegExp)
  return keywords.length > 0 ? new RegExp(`(${keywords.join('|')})`, 'gi') : undefined
}

export const hasHighlights = (text?: ReactNode, highlights: string[] = []): boolean => {
  if (!text || typeof text !== 'string') {
    return false
  }
  const highlightsRegexp = getHighlightsRegexp(highlights)
  if (!highlightsRegexp) {
    return false
  }
  return text.search(highlightsRegexp) >= 0
}

export const replaceHighlights = (text?: ReactNode, highlights: string[] = []): ReactElement => {
  if (!text || typeof text !== 'string') {
    return <></>
  }
  const highlightsRegexp = getHighlightsRegexp(highlights)
  if (!highlightsRegexp) {
    return <>{text}</>
  }
  return (
    <>
      {reactStringReplace(text, highlightsRegexp, (match: string, index: number) => (
        <em key={index}>{match}</em>
      ))}
    </>
  )
}
